// This is used externally by the whiteboard package to load the SVG icons asynchronously.
export const loadCloudArchIcons = async () => {
  const { default: loadCloudArchIcons } = await import(
    /* webpackChunkName: "whiteboard_icon_sets" */ 'components/whiteboards/loadCloudArchIcons'
  );
  return loadCloudArchIcons;
};
